import { BowlBlock } from '@websolutespa/payload-plugin-bowl';
import { options } from '../../options';
import { withIntegration } from './withIntegration';

export const LlmKbConfluence: BowlBlock = withIntegration(options.slug.llmKbConfluence, [
  {
    name: 'password',
    type: 'withText',
    admin: {
      description: 'confluence_password',
    },
  },
  {
    name: 'accessToken',
    type: 'withText',
    admin: {
      description: 'confluence_accessToken',
    },
  },
  {
    name: 'url',
    type: 'withText',
    required: true,
    admin: {
      description: 'confluence_url',
    },
  },
  {
    name: 'userEmail',
    type: 'withText',
    required: true,
    admin: {
      description: 'confluence_userEmail',
    },
  },
  {
    name: 'spaces',
    type: 'text',
    hasMany: true,
    admin: {
      description: 'confluence_spaces',
    },
  },
  {
    name: 'maxNumOfDocsFromEachSpace',
    type: 'number',
    admin: {
      description: 'confluence_maxNumOfDocsFromEachSpace',
    },
    defaultValue: 500,
    min: 1,
    max: 5000,
  },
  {
    name: 'extension',
    type: 'text',
    hasMany: true,
    admin: {
      description: 'confluence_extension',
    },
  },
  {
    name: 'cqlFilter',
    type: 'withText',
    admin: {
      description: 'confluence_CQL_filter',
    },
  },
]);
